import { NO_VALUE_PLACEHOLDER } from "../../common/ConstantValues";
import { humanizeEnumValue } from "../../common/EnumUtils";
import { FieldState, Status } from "../data_point/models/TagsModels";
import { TrackersStateEnum } from "../trackers/TrackersModels";
import { Tags } from "../data_point/tags/TagCatalog";
import { isTagForDevice } from "../data_point/tags/TagCatalogUtils";
import { formatDuration } from "../../common/StringUtils";

export const convertValueToFieldState = (value: number) => {
  switch (value) {
    case FieldState.WindSafe:
    case FieldState.UpsEmergency:
    case FieldState.EngineerEmergency:
    case FieldState.CloudEmergency:
    case FieldState.WindForecastEmergency:
    case FieldState.UpsRecoverySafe:
    case FieldState.ExternalScadaEmergency:
    case FieldState.TrackingUnauthorizationEmergency:
    case FieldState.SnowForecastEmergency:
      return "Safe";
    case FieldState.Sleep:
      return "Night";
    case FieldState.Tracking:
      return "Operational";
    case FieldState.Undefined:
      return NO_VALUE_PLACEHOLDER;
    default:
      return humanizeEnumValue(FieldState[value]) ?? NO_VALUE_PLACEHOLDER;
  }
};

export const isFieldStateBlinking = (valueAsString: string) => {
  if (valueAsString === "Disconnected") {
    return true;
  }
  return false;
};

export const convertValueToStatus = (value: number) =>
  humanizeEnumValue(Status[value]) ?? NO_VALUE_PLACEHOLDER;

export const defaultConvertToString = (value: number) => {
  return Number.parseFloat(value.toFixed(1)).toString();
};

export const convertToTrackerState = (value: number) =>
  humanizeEnumValue(TrackersStateEnum[value]) ?? NO_VALUE_PLACEHOLDER;

export function getConverterFunction(tag: string): (v: number) => string {
  if (isTagForDevice(Tags.TrackerStatus.CurrentState.logicalName, tag)) {
    return convertToTrackerState;
  }
  if (isTagForDevice(Tags.TrackerStatus.Uptime.logicalName, tag)) {
    return formatDuration;
  }
  switch (tag) {
    case Tags.Portal.Inverter.SystemStatus.logicalName:
    case Tags.Portal.TrackerStatus.SystemStatus.logicalName:
      return convertValueToStatus;
    case Tags.Portal.System.FieldState.logicalName:
      return convertValueToFieldState;
    default:
      return defaultConvertToString;
  }
}
